/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import Rails from '@rails/ujs'
// import * as Turbo from '@hotwired/turbo'
import 'controllers'
import { scrollFunction } from './helpers.js'
import { hotjarTrackingCode } from './hotjar.js'

const jQuery = require('jquery')

// include jQuery in global and window scope (so you can access it globally)
global.$ = global.jQuery = jQuery
window.$ = window.jQuery = jQuery

Rails.start()
// Turbo.start()

$('document').ready(function () {
  // Initialize Hotjar (on AppMode only)
  if (isAppMode()) hotjarTrackingCode()

  // scroll to top
  window.onscroll = function scrollToTop() {
    scrollFunction()
  }

  $(document).on(
    'click',
    '.leaflet-control-attribution .trip-edit__inner .button--option',
    (e) => {
      e.preventDefault()
    }
  )
  $(document).on('click', '[data-picker-close], .picker__overlay', (e) => {
    e.preventDefault()
    $('.picker').remove()
    $('body').removeClass('no-scroll')
  })
  $(document).on('click', '.button--option', function setJourneyType() {
    const journeyId = $(this).data('journey-id-encoded')
    const tagId = $(this).data('tag-id')
    $(`#${journeyId}_tag_id`).val(tagId)

    // Reset all buttons
    $(this)
      .parent()
      .find('.button--option-active')
      .removeClass('button--option-active')
    // Mark this button as active
    $(this).addClass('button--option-active')
  })
})
